import React from "react";

const Hire = ({label = 'CONTRATAR'}) => {
    return (
        <a className="mt-9 btn-primary px-[30px] no-underline text-white w-max"
           href={`${process.env.REACT_APP_WHATSAPP_URL}`}>
            {label}
        </a>
    );
};
export default Hire
